<div style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-l hero-banner" id="hero">
			<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>FULL-STACK JAVA WEB FRAMEWORK</div>
			<h1 class="hero-heading" waHeading="xl" waText>Write Java. Ship Web Apps.</h1>
			<p class="hero-subtitle" waBody="l" waColorText="quiet" waText>Build complete web applications in pure Java. JWebMP generates Angular 21 SPAs from annotated Java classes &mdash; or hosts on Vert.x 5 with GuicedEE services. One language. Two modes. Zero TypeScript.</p>
			<div class="wa-cluster wa-gap-s hero-tags">
				<wa-tag pill variant="brand">Java 25+</wa-tag>
				<wa-tag pill variant="danger">Angular 21</wa-tag>
				<wa-tag pill variant="warning">Vert.x 5</wa-tag>
				<wa-tag pill variant="success">JPMS</wa-tag>
				<wa-tag pill variant="neutral">20+ Plugins</wa-tag>
			</div>
			<div class="wa-cluster wa-gap-s hero-ctas">
				<wa-button [routerLink]="['/getting-started']" variant="brand">Get Started</wa-button>
				<wa-button [routerLink]="['/about']" appearance="outlined" variant="neutral">About JWebMP</wa-button>
				<wa-button [routerLink]="['/plugins']" appearance="outlined" variant="neutral">Browse Plugins</wa-button>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section" id="why-jwebmp">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>WHY JWEBMP</div>
				<h2 waHeading="l" waText>Everything You Need, Nothing You Don't</h2>
				<p waBody="m" waColorText="quiet" waText>A complete web framework that respects Java developers.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<div class="wa-grid wa-gap-m" style="--min-column-size:14rem;">
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Annotation-Driven</h3>
							<p waBody="m" waColorText="quiet" waText>Annotate your Java classes and the build generates a complete Angular 21 project. No hand-written TypeScript.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Compile-Time Safe</h3>
							<p waBody="m" waColorText="quiet" waText>Every HTML element, CSS property, and event handler is a Java type. Errors are caught by the compiler, not discovered in the browser.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Dual Mode</h3>
							<p waBody="m" waColorText="quiet" waText>Add the Angular plugin for a generated SPA, or run without it for hosted mode on Vert.x 5 with GuicedEE services. Same component code either way.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Reactive &amp; Non-Blocking</h3>
							<p waBody="m" waColorText="quiet" waText>Built on Vert.x 5 event-loop server and GuicedEE dependency injection. JPMS modular, JLink-ready, production-grade.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Real-Time Ready</h3>
							<p waBody="m" waColorText="quiet" waText>REST, AJAX events, Vert.x event bus, and RabbitMQ &mdash; start with request/response, layer in push updates when you need them.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>IDE-Friendly</h3>
							<p waBody="m" waColorText="quiet" waText>Concrete Java classes with full autocomplete, refactoring, find-usages, and go-to-definition in IntelliJ, Eclipse, or VS Code.</p>
						</div>
					</wa-card>
				</div>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section" id="component-ecosystem">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>20+ PLUGINS</div>
				<h2 waHeading="l" waText>Production-Ready Component Library</h2>
				<p waBody="m" waColorText="quiet" waText>Grids, charts, calendars, icons, messaging &mdash; all type-safe, all Java, all JPMS.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<p waBody="m" waText>Every plugin is a JPMS module. Add the Maven dependency, and the component is available as a type-safe Java class. Some plugins work in both modes; others &mdash; like AG Grid and AG Charts &mdash; require the Angular plugin.</p>
				<div class="wa-grid wa-gap-m" style="--min-column-size:14rem;">
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>AG Grid &amp; AG Charts</h3>
							<p waBody="m" waColorText="quiet" waText>Enterprise data grids and 38+ chart types &mdash; configured in Java, rendered in Angular.</p>
							<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.plugins:aggrid / agcharts</div>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>WebAwesome</h3>
							<p waBody="m" waColorText="quiet" waText>Modern, accessible UI component library with dark mode, responsive layout, and 18+ components.</p>
							<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.plugins:web-awesome</div>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>FullCalendar</h3>
							<p waBody="m" waColorText="quiet" waText>Drag-and-drop scheduling, resource timelines, and multiple calendar views.</p>
							<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.plugins:fullcalendar</div>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>RabbitMQ Comms</h3>
							<p waBody="m" waColorText="quiet" waText>Bidirectional messaging with broker-backed durability. STOMP/WebSocket bridge for Angular.</p>
							<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp:jwebmp-rabbitmq</div>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Font Awesome</h3>
							<p waBody="m" waColorText="quiet" waText>6,000+ icons &#40;Free&#41; or 10,000+ &#40;Pro&#41; rendered as SVG with type-safe Java enums.</p>
							<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.plugins:fontawesome</div>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Chart.js</h3>
							<p waBody="m" waColorText="quiet" waText>Lightweight charts &mdash; bar, line, pie, doughnut, radar &mdash; for dashboards and reports.</p>
							<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.plugins:chartjs</div>
						</div>
					</wa-card>
				</div>
				<div class="wa-cluster wa-gap-s">
					<wa-button [routerLink]="['/plugins']" variant="brand">Full Plugin Catalog</wa-button>
				</div>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section cta-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Ready to Build?</h2>
				<p waBody="m" waColorText="quiet" waText>From zero to production Angular app &mdash; entirely in Java.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<p waBody="l" waText>Stop context-switching between Java and TypeScript. Build your entire web application in the language you already know.</p>
				<div class="wa-cluster wa-gap-s hero-ctas">
					<wa-button [routerLink]="['/getting-started']" variant="brand">Get Started</wa-button>
					<wa-button [routerLink]="['/about']" appearance="outlined" variant="neutral">About JWebMP</wa-button>
					<wa-button appearance="outlined" href="https://github.com/GedMarc/JWebMP" target="_blank" variant="neutral">View on GitHub</wa-button>
				</div>
			</div>
		</div>
	</div>
</div>